import { useEffect, useRef } from 'react';
import { UseRegroupOnPendencyChangeParams } from './useRegroupOnPendencyChange.types';

const PENDENCY_SIGNATURE_SEPARATOR = ',';

const useRegroupOnPendencyChange = ({
  pendingOrderProductKeys,
  isEnabled,
  hasProductUpdating,
  regroup,
}: UseRegroupOnPendencyChangeParams) => {
  const pendencySignature = [...pendingOrderProductKeys].sort().join(PENDENCY_SIGNATURE_SEPARATOR);
  const previousSignatureRef = useRef(pendencySignature);

  useEffect(() => {
    if (hasProductUpdating || pendencySignature === previousSignatureRef.current) {
      return;
    }

    previousSignatureRef.current = pendencySignature;

    if (isEnabled) {
      regroup();
    }
  }, [pendencySignature, isEnabled, hasProductUpdating, regroup]);
};

export default useRegroupOnPendencyChange;
